import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const featuredCreators = [
  {
    name: "Ellis Ever After",
    role: "Podcast",
    image: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=800&h=1000&fit=crop",
  },
  {
    name: "Throwing Fits",
    role: "Culture",
    image: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=800&h=1000&fit=crop",
  },
  {
    name: "Rachel Maksy",
    role: "Video",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&h=1000&fit=crop",
  },
  {
    name: "Jade Novah",
    role: "Music",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&h=1000&fit=crop",
  },
];

const HeroSection = () => {
  return (
    <section className="relative pt-28 pb-20 overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="space-y-10"
          >
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight text-gray-900 tracking-tight">
              Where creators grow
            </h1>

            <p className="text-xl lg:text-2xl text-gray-700 max-w-xl">
              Patreon is the best place to build community with your biggest fans, share exclusive work, and turn your passion into a lasting creative business.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 max-w-xl">
              {["Memberships and shops", "Posts, video, audio, chat", "Built-in payments", "Simple setup"]
                .map((item) => (
                  <div key={item} className="flex items-center gap-3 text-gray-800">
                    <span className="inline-flex h-2.5 w-2.5 rounded-full bg-[#FF424D]" aria-hidden />
                    <span className="text-base font-medium">{item}</span>
                  </div>
                ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/create"
                className="inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-white rounded-full transition-all duration-200 hover:opacity-90"
                style={{ background: "#FF424D" }}
              >
                Get started
              </Link>
              <Link
                to="/discover"
                className="inline-flex items-center justify-center px-10 py-4 text-lg font-semibold text-gray-900 rounded-full border border-gray-300 hover:border-gray-400 transition-all duration-200"
              >
                Explore creators
              </Link>
            </div>

            <p className="text-base text-gray-500">
              Already have an account?{" "}
              <Link
                to="/login"
                className="font-semibold hover:underline transition-colors"
                style={{ color: "#FF424D" }}
              >
                Log in
              </Link>
            </p>
          </motion.div>

          {/* Right Content - Creator collage */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-2 gap-4 lg:gap-6"
          >
            {featuredCreators.map((creator, index) => (
              <div
                key={creator.name}
                className="relative rounded-2xl overflow-hidden shadow-xl bg-gray-100"
                style={{ aspectRatio: index % 3 === 0 ? "3 / 4" : "4 / 5" }}
              >
                <img
                  src={creator.image}
                  alt={creator.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white space-y-1">
                  <p className="text-xs uppercase tracking-wide opacity-80">{creator.role}</p>
                  <p className="text-lg font-semibold leading-tight">{creator.name}</p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
